import { render, staticRenderFns } from "./GreatEventMobile.vue?vue&type=template&id=56066af4&scoped=true"
import script from "./GreatEventMobile.vue?vue&type=script&lang=js"
export * from "./GreatEventMobile.vue?vue&type=script&lang=js"
import style0 from "./GreatEventMobile.vue?vue&type=style&index=0&id=56066af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56066af4",
  null
  
)

export default component.exports